import axiosInstance from '../../module/axios.module';

export interface ISalvarPropostaParcela {
  idlan: number;
  codcoligada: number;
}

export interface ISalvarPropostaAtrasada {
  numVenda: number;
  parcela: ISalvarPropostaParcela[];
}

export default async function SalvarPropostaAtrasada(
  data: ISalvarPropostaAtrasada,
  access_token: string,
) {
  const url = `Proposta/SalvarPropostaAtrasada`;

  const response = await axiosInstance.post(url, data, {
    headers: {
      Authorization: `Bearer ${access_token}`,
    },
  });

  return response.data as {
    Success: boolean;
    Message: string;
    Data: number;
    Total: number;
  };
}
